import React from "react";
import iconDark from "../../assets/norse3-icon-dark.png";

// Official norse3 "n3" icon tile + wordmark.
export default function Logo({ size = 36, withWordmark = true, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <img
        src={iconDark}
        alt="norse3"
        width={size}
        height={size}
        className="rounded-[22%] ring-1 ring-white/10 select-none shrink-0"
        style={{ width: size, height: size }}
      />
      {withWordmark && (
        <span className="font-heading text-[1.15rem] font-semibold tracking-tight text-foreground lowercase">
          norse3
        </span>
      )}
    </span>
  );
}
